<script setup>
import { useI18n } from 'vue-i18n';
import { toIntlLocale } from 'shared/helpers/intlLocale';
const { locale } = useI18n();

defineProps({
  label: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
});
const formatDate = timestamp => new Intl.DateTimeFormat(toIntlLocale(locale.value), {
  dateStyle: 'short', timeStyle: 'short',
}).format(new Date(timestamp * 1000));
</script>

<template>
  <div class="flex flex-col gap-2 w-full md:flex-row md:justify-between md:gap-3">
    <span
      class="text-sm h-fit font-normal text-n-slate-11 md:sticky md:top-0 md:min-w-0"
    >
      {{ label }}
    </span>
    <div class="flex flex-col min-w-0 w-full gap-2">
      <span
        v-for="item in items"
        :key="item.id"
        class="text-sm font-normal text-n-slate-12 text-left md:text-right tabular-nums"
      >
        {{ formatDate(item.created_at) }}
      </span>
      <slot name="showMore" />
    </div>
  </div>
</template>
